/* eslint-disable camelcase */
import {
    FieldStructure,
    DateTimePickerFieldStructure,
} from '@mercell/form-react';
import * as yup from 'yup';
import { FormDefinitionItem } from '../../types/generated/formDefinitionItem';
import { TFunction } from 'react-i18next';
import { getRulesSetup } from '../getRulesSetup';
import { addDays, format, parseISO } from 'date-fns';
import { getPlaceHolder } from '../utilities/dateFormat';
import { DateFns } from '../dateFnsFormats';
import { formatInTimeZone } from 'date-fns-tz';

export const mapDatepickerField = (
    formDefinition: FormDefinitionItem,
    genericFieldStructure: FieldStructure,
    t: TFunction<string, unknown>,
    dateFormat: DateFns,
    locale?: Locale,
    noticeTimeZone?: string,
    featureFlagUseUtcDatesOnly?: boolean
): DateTimePickerFieldStructure => {
    if (genericFieldStructure.associatedValidationBasedOnOtherFieldValues) {
        if (
            formDefinition.conditionalValidation?.rules &&
            formDefinition.conditionalValidation.rules.some(
                (rule) => !!rule.function
            ) &&
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues
        ) {
            const conditionalValidations = getRulesSetup(
                yup
                    .date()
                    .nullable()
                    .transform((value, originalValue) => {
                        if (!originalValue) return null;
                        return parseISO(originalValue);
                    }),
                formDefinition.conditionalValidation.rules,
                t,
                '',
                locale
            );
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues.rules =
                conditionalValidations;
        }
    }
    return {
        ...genericFieldStructure,
        id: formDefinition.name,
        validations: formDefinition.rules
            ? getRulesSetup(
                  yup
                      .date()
                      .nullable()
                      .transform((value, originalValue) => {
                          if (!originalValue) return null;
                          return parseISO(originalValue);
                      }),
                  formDefinition.rules,
                  t,
                  '',
                  locale
              )
            : undefined,
        type: 'date-time-picker',
        submitWithTimeZone: true,
        disabled: formDefinition.disabled,
        dateFormat:
            featureFlagUseUtcDatesOnly && noticeTimeZone
                ? dateFormat.DateWithZoneLong
                : dateFormat.Date,
        showDateRangeWithTimeZone: false,
        startDateRangeFormat: dateFormat?.DateTime,
        endDateRangeFormat: dateFormat?.DateTimeWithZoneLong,
        placeholder: locale
            ? getPlaceHolder(locale?.formatLong?.date({ width: 'short' }))
            : 'DD/MM/YYYY',
        locale,
        timeZone: featureFlagUseUtcDatesOnly ? noticeTimeZone : undefined,
    };
};

export const mapDatepickerReadOnly = (
    content: any,
    showWithTime: boolean,
    dateFormat: DateFns,
    locale?: Locale,
    featureFlagUseUtcDatesOnly?: boolean,
    noticeTimeZone?: string
) => {
    if (!content) return undefined;

    try {
        const parsedDate = parseISO(content);
        return format(
            parsedDate,
            showWithTime ? dateFormat.DateTime : dateFormat.Date,
            { locale }
        );
    } catch (error) {
        console.error('Date parsing error:', error);
        return content;
    }
};
